/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import InputBox from '../../../components/InputBox'
import Dropdown from '../../../components/Dropdown'
import TextArea from '../../../components/TextArea'
import {useState,useContext} from "react"
import { useDispatch,useSelector } from 'react-redux'
import ErrorMessage from '../../../components/ErrorMessage'

import GlobalContext from '../../../components/Context/GloablContext'

export default function SetGlobalVariables({type,setType,emptyField,sessionError,setIsDisableCancel,
    setSessionError,maxFailError,
    setMaxFailError,setEmptyField,globalVariables,setGlobalVariables,emailError,setEmailError,countryCodes}) {
    const {setToastmessage, isSideNavBar,UpdateCall, setUpdateCall,setToastErrorMessage} =useContext(GlobalContext)
    const auth=useSelector(state=>state?.auth)
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
    

    function handleOnChangeInput(id,option){
        setEmailError(false)
        setSessionError(false)
        setMaxFailError(false)
        const fieldToUpdate = {
            date_format:"date_format",
            country_code:"country_code",
            max_file_size:"max_file_size",
            email_addr:"email_addr",
            session_timeout:"session_timeout",
            public_encryp_key:"public_encryp_key",
            browser_trust_duration:"browser_trust_duration",
            temp_pass_duration:"temp_pass_duration",
            recent_otp_durn:"recent_otp_durn",
            max_failed_attempts:"max_failed_attempts",
            otp_validity_durn:"otp_validity_durn"
           
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true
        
        if (id !== "date_format"&&id!=="country_code"&&id!=="email_addr"&&id!=="public_encryp_key") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
            
        }
        
        if(!isValid){
            if (fieldToUpdate) {
                setGlobalVariables((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        setToastErrorMessage("")
        setEmptyField(false)
       
        if (fieldToUpdate) {
            setIsDisableCancel(false)
            if (fieldToUpdate === "email_addr") {
                if (option.length <= 80) {
                    setGlobalVariables((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }

            }
            else if (fieldToUpdate!=="public_encryp_key"&&fieldToUpdate!==""&&fieldToUpdate!=="country_code"&& option.length <= 30) {
                setGlobalVariables((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
            else if(fieldToUpdate==="public_encryp_key"||fieldToUpdate==="date_format"||fieldToUpdate==="country_code"){
                setGlobalVariables((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));

            }
           
        }
    }
    function handleAllowEdit(){
        setType("edit")
    }  
    return (
        <>
            <div className='flex justify-between'>
                <div>
                    <h1 className='mb-4 text-lg font-normal text-black'>Set Global Variables</h1>
                    <p className='text-sm font-normal text-[#52555D] mb-2'>{`"Set Global Variable" lets you control how things look and work in your 
                    app across different screens by using shared settings that you can change from one central place.`}</p>
                </div>
                {userType==="super-admin"&&<button id="edit" type='button' onClick={handleAllowEdit} className={`w-max px-4 py-2.5 border border-[#972E4C] h-fit rounded-[16px] items-center  ${type==="view"?"flex":"hidden"}`}>
                    <span className='w-5'><img src="images/edit_icon.svg" alt="icon"/></span>
                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                </button>}
            </div>
            <div className='px-6 py-4 rounded-lg bg-[#E7EAF4]'>
                {type === "add"||type==="edit" ? 
                    <>
                        <div className='flex -mx-[18px] mb-5'>
                            <div className='w-1/3 px-[18px]'>
                                <div className='w-full'>
                                    <Dropdown 
                                        label={"Date Format"} 
                                        placeholder={"Select date format"}
                                        id={"date_format"}
                                        htmlFor={"dateFormat"}
                                        value={globalVariables.date_format}
                                        options={['MM/DD/YYYY, AM/PM, Leading zeros','MM/DD/YYYY, AM/PM, No leading zeros','MM/DD/YYYY, 24hrs, Leading zeros','MM/DD/YYYY, 24hrs, No leading zeros','DD/MM/YYYY, AM/PM, Leading zeros','DD/MM/YYYY, AM/PM, No leading zeros','DD/MM/YYYY, 24hrs, Leading zeros','DD/MM/YYYY, 24hrs, No leading zeros']}
                                        emptyField={emptyField&&globalVariables?.date_format?.trim()===""}
                                        handleOnChangeInput={handleOnChangeInput}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px]'>
                                <div className='w-full'>
                                    <Dropdown
                                        label={"Country Code"}
                                        id={"country_code"}
                                        placeholder={'Country Code'}
                                        value={globalVariables.country_code}
                                        options={countryCodes}
                                        handleOnChangeInput={handleOnChangeInput}
                                        emptyField={emptyField&&globalVariables.country_code===""}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px]'>
                                <div className='w-full'>
                                    <InputBox 
                                        label={"Session Timeout"} 
                                        placeholder={"Enter session timeout"}
                                        id={"session_timeout"}
                                        htmlFor={"sessionTimeout"}
                                        isUnit={true}
                                        unitType={"Minutes"}
                                        value={globalVariables.session_timeout}
                                        emptyField={emptyField&&globalVariables?.session_timeout===""}
                                        sessionError={sessionError}
                                        handleOnChangeInput={handleOnChangeInput}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='flex -mx-[18px]'>
                            <div className='w-2/3 px-[18px]'>
                                <div className='flex -mx-[18px] flex-wrap'>
                                    <div className='w-1/2 px-[18px] mb-5'>
                                        <div className='flex flex-col relative'>
                                            <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] pb-1.5'>Maximum File Size</label>
                                            {/* border-[#D3454D] */}
                                            <div className='relative'>
                                                
                                                <InputBox 
                                                    label={""}
                                                    placeholder={"Enter maximum file size"}
                                                    id={'max_file_size'}
                                                    htmlFor={"MaximumfileSize"}
                                                    isUnit={true}
                                                    value={globalVariables.max_file_size}
                                                    unitType={"Mb"}
                                                    emptyField={emptyField&&globalVariables?.max_file_size?.toString()?.trim()==""}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                    maxLength={5}
    
                                                />

                                            </div>
                                        </div> 
                                    </div>
                                    <div className='w-1/2 px-[18px] mb-5'>
                                        <div className='w-full'>
                                            <InputBox 
                                                label={"Email Address"} 
                                                placeholder={"Enter email address"}
                                                id={"email_addr"}
                                                htmlFor={"emailAddress"}
                                                value={globalVariables.email_addr}
                                                emptyField={emptyField&&globalVariables?.email_addr?.trim()===""}
                                                emailError={emailError}
                                                handleOnChangeInput={handleOnChangeInput}
                                            />
                                            {emailError && <ErrorMessage error  message={"Invalid email address"}/>}
                                        </div>
                                    </div>
                                    <div className='w-1/2 px-[18px] mb-5'>
                                        <div className='flex flex-col relative'>
                                            <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] pb-1.5'>Browser Trust Duration</label>
                                            {/* border-[#D3454D] */}
                                            <div className='relative'>
                                                <InputBox 
                                                    label={""}
                                                    placeholder={"Enter browser trust duration"}
                                                    id={'browser_trust_duration'}
                                                    htmlFor={"browserTrustDuration"}
                                                    isUnit={true}
                                                    value={globalVariables.browser_trust_duration}
                                                    unitType={"Days"}
                                                    emptyField={emptyField&&globalVariables?.browser_trust_duration?.trim()===""}
                                                    handleOnChangeInput={handleOnChangeInput}
    
                                                />
                                            </div>
                                        </div> 
                                    </div>
                                    <div className='w-1/2 px-[18px] mb-5'>
                                        <div className='flex flex-col relative'>
                                            <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] pb-1.5'>Resend OTP Duration</label>
                                            {/* border-[#D3454D] */}
                                            <div className='relative'>
                                                <InputBox 
                                                    label={""}
                                                    placeholder={"Enter resend OTP duration"}
                                                    id={'recent_otp_durn'}
                                                    htmlFor={"resendOtpDuration"}
                                                    isUnit={true}
                                                    value={globalVariables.recent_otp_durn}
                                                    unitType={"Seconds"}
                                                    emptyField={emptyField&&globalVariables?.recent_otp_durn?.trim()===""}
                                                    handleOnChangeInput={handleOnChangeInput}
                                                />
                                                
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px] mb-5'>
                                <TextArea label={'Public Encryption Key'}
                                    htmlFor={'Public_Encryption_Key'}
                                    id={'public_encryp_key'}
                                    value={globalVariables.public_encryp_key}
                                    placeholder={'Enter encryption key'}
                                    emptyField={emptyField&&globalVariables?.public_encryp_key?.trim()===""}
                                    handleOnChangeInput={handleOnChangeInput}
                                />   
                            </div>
                        </div>
                        <div className='-mx-[18px] flex'>
                            <div className='w-1/3 px-[18px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] pb-1.5'>Temporary Password Expiry Duration</label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        {/* <input type="text" id='Maximum_File_Size' 
                                            className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-sm font-normal 
                                    text-[#000B17] w-full placeholder:text-[#52555D] outline-none' placeholder='Enter expiry duration' />
                                        <div className='border-l border-[#E7EAF4] absolute top-1/2 right-[35px] py-1.5 -translate-y-1/2'>
                                            <p className='text-xs font-semibold text-[#52555D] pl-2.5'>Hours</p>
                                        </div> */}
                                        <InputBox 
                                            label={""}
                                            placeholder={"Enter expiry duration"}
                                            id={'temp_pass_duration'}
                                            htmlFor={"temp_pass_duration"}
                                            value={globalVariables.temp_pass_duration}
                                            isUnit={true}
                                            unitType={"Hours"}
                                            emptyField={emptyField&&globalVariables?.temp_pass_duration?.trim()===""}
                                            handleOnChangeInput={handleOnChangeInput}
                                        />
                                        
                                    </div>
                                </div> 
                            </div>
                            <div className='w-1/3 px-[18px]'>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Max Failed Login Attempts "} 
                                        placeholder={"Enter max failed login attempts"}
                                        id={"max_failed_attempts"}
                                        value={globalVariables.max_failed_attempts}
                                        htmlFor={"max-failed_attempts"}
                                        emptyField={emptyField&&globalVariables?.max_failed_attempts?.toString()?.trim()===""}
                                        handleOnChangeInput={handleOnChangeInput}
                                        maxFailError={maxFailError}
                                    />
                                </div>
                            </div>
                            <div className='w-1/3 px-[18px]'>
                                <div className='flex flex-col relative'>
                                    <label htmlFor='Maximum_File_Size' className='text-xs font-semibold text-[#000] pb-1.5'>OTP Validity Duration </label>
                                    {/* border-[#D3454D] */}
                                    <div className='relative'>
                                        <InputBox 
                                            label={""}
                                            placeholder={"Enter OTP validity duration"}
                                            id={'otp_validity_durn'}
                                            htmlFor={"OtpValidityDuration"}
                                            isUnit={true}
                                            value={globalVariables.otp_validity_durn}
                                            unitType={"Minutes"}
                                            emptyField={emptyField&&globalVariables?.otp_validity_durn?.trim()===""}
                                            handleOnChangeInput={handleOnChangeInput}
    
                                        />
                                        
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className='flex -mx-1 flex-wrap'>
                            {Object.entries({
                                'Date Format': globalVariables?.date_format,
                                'Country Code': globalVariables?.country_code,
                                'Session Timeout': `${globalVariables?.session_timeout} Minutes`,
                                'Maximum File Size': `${globalVariables?.max_file_size} Mb`,
                                'Email Address': globalVariables?.email_addr,
                                'Browser Trust Duration': `${globalVariables?.browser_trust_duration} Days`,
                                'Resend OTP Duration': `${globalVariables?.recent_otp_durn} Seconds`,
                                'OTP Validity Duration': `${globalVariables?.otp_validity_durn} Minutes`,
                                'Temporary Password Expiry Duration': `${globalVariables?.temp_pass_duration} Hours`,
                                'Max Failed Login Attempts': globalVariables?.max_failed_attempts,
                                'Public Encryption Key': globalVariables?.public_encryp_key,
                            }).map(([label, value,index]) => (
                                <div key={label} className='px-1 w-1/5 mb-8'>
                                    <div className='w-full'>
                                        <p className='text-xs font-normal text-[#000] pb-1.5'>{label}</p>
                                        <p className='text-base font-normal text-[#000B17] break-words'>{value===""?"-":value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                }
            </div>
        </>
    )
}
